import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface SubscriptionData {
  userId: string
  handle: string
  // include whatever else your CreatorsList needs
}

interface SubscriptionCacheState {
  byKey: Record<string, SubscriptionData[]>
  setSubscriptions: (key: string, data: SubscriptionData[]) => void
  getSubscriptions: (key: string) => SubscriptionData[] | undefined
  clear: () => void
}

export const useSubscriptionCacheStore = create<SubscriptionCacheState>()(
  persist(
    (set, get) => ({
      byKey: {},

      setSubscriptions: (key, data) =>
        set(state => ({
          byKey: { ...state.byKey, [key]: data }
        })),

      getSubscriptions: (key) => get().byKey[key],

      clear: () => set({ byKey: {} })
    }),
    {
      name: 'subscription-cache',
      partialize: (state): Partial<SubscriptionCacheState> => ({
        byKey: state.byKey
      })
    }
  )
)